<template>
  <div>
    <div v-if="loading" class="loadingDiv">
      <div class="loading"></div>
    </div>
    <div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
        You have only view permission.
      </div>
      <div class="row-container marginb" v-show="ifTeamleaderPermission">
        <div class="row-container align-center">
          <img src="@/assets/download.svg" class="Group-5"/>
          <button
            class="text-green"
            @click="payComponentsDetails"
          >Pay Component Details</button>
          <img v-if="credentialSpecific" src="@/assets/group-5.svg" class="Group-5" />
          <button
            v-if="credentialSpecific"
            class="text-green"
            @click="$router.push(`/onboarding/entity/${$route.params.entity_index}/preferences/addComponent`)"
          >Add New Component</button>
        </div>
      </div>
      <div :disabled="!(ifTeamleaderPermission)">
        <data-table
          :columns="columnNames"
          :tableData="componentsData"
          :withForm="false"
          :showinheader="showinheader"
          :search="search"
          :icons="[
                  {url:require('@/assets/garbage.png'), method: 'up'},
                  {url:require('@/assets/garbage.png'), method: 'down'},
                  {url:require('@/assets/garbage.png'), method: 'deletee'}
                  ]"
          @delete="deleteItem"
          :showdelete="false"
          :showedit="credentialSpecific"
          @editStart="editItem"
          @history="viewItem"
          @up="moveRowToUp"
          @down="moveRowToDown"
          @selected="selected"
          @deselected="deselected"
          :showhistory="true"
          class="margin-bottom-50"
        >
          <template v-slot:rowcontent="slotprops">
            <p
              v-if="slotprops.value.column.key == 'salary_component_type' && slotprops.value.record[slotprops.value.column.key] == 'FIXED'"
            >Fixed</p>
            <p
              v-if="slotprops.value.column.key == 'salary_component_type' && slotprops.value.record[slotprops.value.column.key] == 'VARIABLE'"
            >Variable</p>
            <p
              v-if="slotprops.value.column.key=='calculation' && slotprops.value.record[slotprops.value.column.key]"
            >{{ slotprops.value.record['calculation_type'] == 'SLAB' ? '--' : slotprops.value.record[slotprops.value.column.key][0]['formula'] ? slotprops.value.record[slotprops.value.column.key][0]['formula'] : '0' }}</p>
            <p
              v-if=" slotprops.value.column.key != 'SalaryComponentType' && slotprops.value.column.key != 'salary_component_type' && slotprops.value.column.key != 'calculation'"
            >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          </template>
        </data-table>
      </div>
    </div>
    <bottom-action-container>
      <btn-skip @navClicked="$emit('stepNum', 3)"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="$emit('stepNum', 1)" />
          <btn text="Next" type="primary" @click="$emit('stepNum', 3)" />
        </btn-grp>
      </template>
    </bottom-action-container>

    <pop-up-message
      v-if="showConfirmDelete"
      :message="'Are you sure you want to delete ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"
    >
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
          <popup-btn text="Delete" type="primary" @click="confirmDelete" />
        </btn-grp>
      </template>
    </pop-up-message>

    <pop-up-message
      v-if="showDefaultDeletable"
      :message="'You cannot delete this salary component as it is a default component !'"
      :popupType="popupType"
      :popupHeaderMessage="'Warning'"
    >
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="secondary" @click="cancelDefaultPopup" />
        </btn-grp>
      </template>
    </pop-up-message>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "SalaryComponents",
  computed: {
    ...mapState({
      componentTypes: state =>
        state.onboard.settings.salary_component_types.data,
      salaryComponentsData: state =>
        state.onboard.settings.salary_component.entityWiseData,
      userEmailState: (state) => state.auth.email
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else return this.getLegalEntityId(0);
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    componentsData() {
      try {
        return this.salaryComponentsData[this.leId];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.payrollPreferencesValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.payrollPreferencesValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  data() {
    return {
      popupType: "ConfirmDelete",
      currentObj: {},
      showConfirmDelete: false,
      showDefaultDeletable: false,
      errmsg: "",
      toast: false,
      showinheader: false,
      credentialSpecific:false,
      loading:false,
      columnNames: [
        {
          label: "Component",
          key: "name"
        },
        {
          label: "Type",
          key: "salary_component_type"
        },
        {
          label: "Tax Exempt",
          key: "it_section"
        },
        {
          label: "Calculation type",
          key: "calculation_type"
        },
        {
          label: "Calculation",
          key: "calculation"
        }
      ],
      search: "",
      payrollPreferencesValue: false,
      role: ""
    };
  },
  mounted() {
    this.fetchAllComponents();
    this.getOrgLeIdList();
    this.credentialSpecific = this.credentialCheck();
  },
  activated() {
    this.fetchAllComponents();
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      act_fetchAll: "onboard/settings/salary_component/fetchAll",
      act_paycomponentDetails : "onboard/settings/salary_component/paycomponentDetails",
      act_delete: "onboard/settings/salary_component/delete"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),
    credentialCheck(){
      return this.userEmailState == "asif.khan@teamlease.com" ||
        this.userEmailState == "sagar.shetty@teamlease.com" ||
        this.userEmailState == 'abhishek.reddy@teamlease.com' ||
        this.userEmailState == 'mukesh.kumar@teamlease.com' ||
        this.userEmailState == 'rakshitha.raj@teamlease.com' ||
        this.userEmailState == 'akash.kumar@teamlease.com' ||
        this.userEmailState == 'ranjan.ranganath@teamlease.com' ||
        this.userEmailState == 'sudarshan.puttaraju@teamlease.com'
        ? true : false;
    },
    async payComponentsDetails(){
      try {
        let payload ={
          legalEntityId : this.leId,
        }
        this.loading = true
        let res = await this.act_paycomponentDetails(payload);
        this.loading = false
        const fileUrl = res.data.payload;
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', 'Salary_Component_Report.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        } catch (error) {
          this.toast = true;
          this.errmsg = err;
        }
    },

    navHandler(navType) {
      try {
        if (navType == "back") {
          this.$emit("stepNum", 1);
          this.$validator.reset();
        } else if (navType == "next") {
          this.$emit("stepNum", 3);
          this.$validator.reset();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch the Salary components list data from server */
    async fetchAllComponents() {
      try {
        let res = await this.act_fetchAll(this.leId);
        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On delete icon Click */
    deleteItem(item) {
      try {
        if (!item.removed_by_user) {
          this.showDefaultDeletable = true;
        } else {
          this.showConfirmDelete = true;
          this.currentObj = item;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    cancelDefaultPopup() {
      this.showDefaultDeletable = false;
    },

    cancelEvent() {
      this.showConfirmDelete = false;
    },

    confirmDelete() {
      this.deleteEvent();
    },
    /** Function to delete an SC item */
    async deleteEvent() {
      try {
        let res = await this.act_delete(this.currentObj);
        if (res.status == 200) {
          this.showConfirmDelete = false;
          this.fetchAllComponents();
        }
      } catch (err) {
        this.showConfirmDelete = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    async editItem(rec) {
      try {

        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/preferences/modifyComponent`,
          query: { id: rec.id}
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async viewItem(rec) {
      try {
        
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/preferences/viewComponent`,
          query: { id: rec.id}
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    selected(records) {
      this.showinheader = true;
    },
    deselected(records) {
      try {
        if (records.length == 0) {
          this.showinheader = false;
          this.editcol = "";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    moveRowToUp(records) {},
    moveRowToDown(records) {},

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.leId;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.payrollPreferencesValue = data.data.user.permissions.payroll_preferences ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.row-container {
  align-items: center;
  justify-content: flex-end;
}
.Group-5 {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.text-green {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}
.search-bar {
  width: 321px;
  border: 1px solid #d6d4d4;
  border-radius: 3px;
  height: 30px;
  padding: 5px;
  outline: none;
  position: relative;
}
.marginb {
  margin-bottom: 16px;
}
.align-center {
  align-items: center;
}
.margin-bottom-50 {
  margin-bottom: 50px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
.loading {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #376cd3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.loadingDiv{
  display: flex;
  justify-content: center;
  height: 70vh;
  align-items: center;
  position:relative;
  z-index: 30;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
